<template>
	<div v-show="isVisible">
    <slot></slot>
  </div>
</template>

<script>
  import emitter from '../../../mixins/emitter';

	export default {
	  mixins: [emitter],
		name: "e-step",
    props: ['label'],
    data () {
      return {
        stepNumber: '',
        currentStatus: '',
        isVisible: false,
      };
    },
    watch: {
	    isVisible: {
	      handler() {
	        this.$emit('select', this);
        },
        immediate: true,
      }
    },
    methods: {
		  onClick() {
		    this.$emit('click');
      }
    },
    mounted () {
      this.dispatch('e-steps', 'append');
    },
    beforeDestroy () {
      this.dispatch('e-steps', 'remove');
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/steps/step.vue